import moment from 'moment';

export const firestoreRecordToVisit = firestoreVisit => {
  return {
    ...firestoreVisit,
    dateTime: moment(firestoreVisit.dateTime.toDate()).format('YYYY-MM-DDTHH:mm'),
  };
};
